import { createContext, useState, useEffect } from 'react';

import frTranslations from '../locales/fr.json';
import enTranslations from '../locales/en.json';

export const LangContext = createContext();

export const LangProvider = ({ children }) => {
    const [language, setLanguage] = useState('fr');
    const [translations, setTranslations] = useState(frTranslations);

    // Charger la langue sauvegardée au démarrage
    useEffect(() => {
        const savedLanguage = localStorage.getItem('language');
        if (savedLanguage) setLanguage(savedLanguage);
    }, []);

    // Mettre à jour les traductions quand la langue change
    useEffect(() => {
        if (language === 'fr') setTranslations(frTranslations);
        else if (language === 'en') setTranslations(enTranslations);
    }, [language]);

    // Changer la langue
    const toggleLanguage = (lang) => {
        setLanguage(lang);
        localStorage.setItem('language', lang);
    };


    return (
        <LangContext.Provider value={{ translations, toggleLanguage, language }}>
            {children}
        </LangContext.Provider>
    );
};
